import { useStore } from 'effector-react'

import {
  $accounts,
  $accountsError,
  $balanceOperation,
  $wallets,
  $walletsError,
  createBalanceOperation,
} from './model'
import { getAccounts } from '../../../clients/widgets/account/model'
import { getWallets } from '../../../clients/widgets/wallet/model'
import {
  $exchangers,
  $exchangersError,
  getExchanger,
} from '../../widgets/CreateDepositHeadwayForm/model'

export const useCreateBalanceOperation = () => {
  const balanceOperation = useStore($balanceOperation)
  const accounts = useStore($accounts)
  const accountsError = useStore($accountsError)

  const wallets = useStore($wallets)
  const walletsError = useStore($walletsError)

  const exchangers = useStore($exchangers)
  const exchangersError = useStore($exchangersError)

  const createBalanceOperationLoading = useStore(createBalanceOperation.pending)
  const accountsLoading = useStore(getAccounts.pending)
  const walletsLoading = useStore(getWallets.pending)
  const exchangersLoading = useStore(getExchanger.pending)

  return {
    balanceOperation,
    accounts,
    accountsError,
    walletsError,
    wallets,
    exchangers,
    exchangersError,
    createBalanceOperationLoading,
    accountsLoading,
    walletsLoading,
    exchangersLoading,
  }
}
